const layout = () => import('../../internal/dashboard/layoutV2.vue')
const selectedList = () => import('./index.vue')

const selectedListroutes = {
  component: layout,
  children: [
    {
      path: '/selected-list/random',
      name: 'selectedListRandom',
      meta: {
        title: 'selectedListRandom',
        requiresAuth: true,
      },
      component: selectedList,
    },
  ],
}

export default selectedListroutes
